"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const lodash_1 = require("lodash");
const images_1 = require("../../../services/images");
const StopoversWeb = ({ stopovers }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: "details" });
    return !(0, lodash_1.isEmpty)(stopovers) ?
        (0, jsx_runtime_1.jsx)("div", { className: "stopovers", children: stopovers.map((stopover, index) => (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { src: images_1.icons.IntermediatePoint, alt: "" }), (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsxs)("span", { className: "point", children: [t('intermediate_point'), " ", index, ":"] }), " ", stopover] })] }, `Stopover${index}`)) }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.default = StopoversWeb;
